/**
 * @flow
 * @relayHash 1513273a44b2711fbe452bdbe5207d0b
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PackageTrackerNotificationSubscriptionMutationInput = {|
  packageId: number,
  mobileNumber: string,
  token?: ?string,
  clientMutationId?: ?string,
|};
export type mobilePhoneNotificationSubscriptionMutationVariables = {|
  input: PackageTrackerNotificationSubscriptionMutationInput
|};
export type mobilePhoneNotificationSubscriptionMutationResponse = {|
  +packageTrackerNotificationSubscription: ?{|
    +shouldValidateToken: ?boolean,
    +success: boolean,
    +errors: ?$ReadOnlyArray<{|
      +field: ?string,
      +message: ?string,
    |}>,
  |}
|};
export type mobilePhoneNotificationSubscriptionMutation = {|
  variables: mobilePhoneNotificationSubscriptionMutationVariables,
  response: mobilePhoneNotificationSubscriptionMutationResponse,
|};
*/

/*
mutation mobilePhoneNotificationSubscriptionMutation(
  $input: PackageTrackerNotificationSubscriptionMutationInput!
) {
  packageTrackerNotificationSubscription(input: $input) {
    shouldValidateToken
    success
    errors {
      field
      message
    }
  }
}
*/

const node /*: ConcreteRequest*/ = (function() {
  var v0 = [
      {
        kind: 'LocalArgument',
        name: 'input',
        type: 'PackageTrackerNotificationSubscriptionMutationInput!',
        defaultValue: null
      }
    ],
    v1 = [
      {
        kind: 'LinkedField',
        alias: null,
        name: 'packageTrackerNotificationSubscription',
        storageKey: null,
        args: [
          {
            kind: 'Variable',
            name: 'input',
            variableName: 'input'
          }
        ],
        concreteType: 'PackageTrackerNotificationSubscriptionMutation',
        plural: false,
        selections: [
          {
            kind: 'ScalarField',
            alias: null,
            name: 'shouldValidateToken',
            args: null,
            storageKey: null
          },
          {
            kind: 'ScalarField',
            alias: null,
            name: 'success',
            args: null,
            storageKey: null
          },
          {
            kind: 'LinkedField',
            alias: null,
            name: 'errors',
            storageKey: null,
            args: null,
            concreteType: 'ErrorNode',
            plural: true,
            selections: [
              {
                kind: 'ScalarField',
                alias: null,
                name: 'field',
                args: null,
                storageKey: null
              },
              {
                kind: 'ScalarField',
                alias: null,
                name: 'message',
                args: null,
                storageKey: null
              }
            ]
          }
        ]
      }
    ];
  return {
    kind: 'Request',
    fragment: {
      kind: 'Fragment',
      name: 'mobilePhoneNotificationSubscriptionMutation',
      type: 'Mutation',
      metadata: null,
      argumentDefinitions: (v0 /*: any*/),
      selections: (v1 /*: any*/)
    },
    operation: {
      kind: 'Operation',
      name: 'mobilePhoneNotificationSubscriptionMutation',
      argumentDefinitions: (v0 /*: any*/),
      selections: (v1 /*: any*/)
    },
    params: {
      operationKind: 'mutation',
      name: 'mobilePhoneNotificationSubscriptionMutation',
      id: null,
      text:
        'mutation mobilePhoneNotificationSubscriptionMutation(\n  $input: PackageTrackerNotificationSubscriptionMutationInput!\n) {\n  packageTrackerNotificationSubscription(input: $input) {\n    shouldValidateToken\n    success\n    errors {\n      field\n      message\n    }\n  }\n}\n',
      metadata: {}
    }
  };
})();
// prettier-ignore
(node/*: any*/).hash = '6853b1af1d40d3d0cc8a02c2a49a3715';
module.exports = node;
